/**
 * @module services
 */

/**
 * Response Payload contract interface with backend.
 *
 * @author Davinder Singh
 * @export
 * @interface IResponsePayload
 */
export default interface IResponsePayload<T> {
  responseStatus: ResponseStatus;
  responseCode: string;
  responseDesc: string;
    payload: T;
    uniqueId: string;
    msgDesc:string;
  }
  
  /**
   * All possible response statuses.
   *
   * @export
   * @enum {number}
   */
  export enum ResponseStatus {
    success = "S",
    failure = "F",
  }
  